import Config from "../utils/config"
import {useSecurityStore} from "@/stores/security"
import {useAlertStore} from "@/stores/alert"

export default {
    async getByProjectAndDate(userId, data) {
        const securityStore = useSecurityStore()
        const alertStore = useAlertStore()
        return new Promise((resolve, reject) => {
            fetch(`${Config.getApiUrl()}/times?user=${userId}&project=${data.projectId}&date=${data.date}`, {
                headers: {
                    "Authorization" : `Bearer ${securityStore.getToken}`,
                    "Content-type": "application/json"
                },
                method: "GET"
            }).then(response => {
                if (response.ok) return response.json()
            }).then(data => {
                resolve(data)
            }).catch(error => {
                alertStore.addAlert({state: 'danger', message: error.message})
                reject(error)
            })
        })
    },
    async create(data) {
        const securityStore = useSecurityStore()
        const alertStore = useAlertStore()
        return new Promise((resolve, reject) => {
            fetch(`${Config.getApiUrl()}/times`, {
                headers: {
                    "Authorization" : `Bearer ${securityStore.getToken}`,
                    "Content-type": "application/json"
                },
                body: JSON.stringify(data),
                method: "POST"
            }).then(response => {
                if (response.ok) return response.json()
            }).then(data => {
                resolve(data)
            }).catch(error => {
                alertStore.addAlert({state: 'danger', message: error.message})
                reject(error)
            })
        })
    },
    async update(id, data) {
        const securityStore = useSecurityStore()
        const alertStore = useAlertStore()
        return new Promise((resolve, reject) => {
            fetch(`${Config.getApiUrl()}/times/${id}`, {
                headers: {
                    "Authorization" : `Bearer ${securityStore.getToken}`,
                    "Content-type": "application/merge-patch+json"
                },
                body: JSON.stringify(data),
                method: "PATCH"
            }).then(response => {
                if (response.ok) return response.json()
            }).then(data => {
                resolve(data)
            }).catch(error => {
                alertStore.addAlert({state: 'danger', message: error.message})
                reject(error)
            })
        })
    }
}